import { Link } from 'gatsby';
import { withPrefix } from 'gatsby-link';
import React from 'react';

import styles from './Hero.styles';

const Hero = ({
  img,
  imgMobile,
  heroTitle,
  heroText,
  isTitleLight,
  isSponsorTextLight,
  commonData,
  titleFontSize,
  textFontSize,
  mobileTitleFontSize,
  mobileTextFontSize,
}) => {
  const { sponsorLogo } = commonData;

  return (
    <div css={styles(img, imgMobile, titleFontSize, textFontSize, mobileTitleFontSize, mobileTextFontSize)}>
      <div className="heroInfo">
        <div className={`heroInfo-text ${isTitleLight ? 'light' : ''}`}>
          <p className="heroTitle" dangerouslySetInnerHTML={{ __html: heroTitle }} />
          <p className="heroText">{heroText}</p>
        </div>
        <div className="heroInfo-sponsor">
          <p
            className={`supportText ${isSponsorTextLight ? 'light' : ''}`}
            data-sal="fade"
            data-sal-delay="300"
            data-sal-duration="500"
            data-sal-easing="ease-in-cubic"
          >
            {sponsorLogo?.text}
          </p>
          <Link to={sponsorLogo?.href}>
            <img src={withPrefix(sponsorLogo?.image)} alt={sponsorLogo?.alt} className="sponsorImage" />
            <img src={withPrefix(sponsorLogo?.imageMobile)} alt={sponsorLogo?.alt} className="sponsorImageMobile" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Hero;
